export default "__VITE_ASSET__FHaAzIIC__"